import { render, staticRenderFns } from "./roleDetail.vue?vue&type=template&id=936af9f0&scoped=true&"
import script from "./roleDetail.vue?vue&type=script&lang=js&"
export * from "./roleDetail.vue?vue&type=script&lang=js&"
import style0 from "./roleDetail.vue?vue&type=style&index=0&id=936af9f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936af9f0",
  null
  
)

export default component.exports